import { useForm as createUseForm } from "@ant-design-vue/use";
import { Button, Col, notification, Row } from 'ant-design-vue';
import { defineAsyncComponent } from "vue";
import { addModal, setIsLoading as setIsLoadingApp } from '../../../app.logic';
import { createFieldDate, createFieldImage, createFieldInput, createFieldInputNumber, createFieldSelect, createFieldTreeSelect } from "../../../components/input/template-builder/template-builder.logic";
import { setAppPageHeader } from "../../../components/layout/app-layout/app-layout.logic";
import i18n from "../../../i18n";
import store from "../../../store";
import { createButtonSave } from "../../../utils/button";
import { modalStyleForm } from "../../../utils/constant";
import { initUseForm } from '../../../utils/form';
import { createLoading } from '../../../utils/loading';
import { has } from "../../../utils/menu-context";
import { required, validateError } from "../../../utils/validate";
import lodash from 'lodash'

const ChangePassword = defineAsyncComponent(() => import('./ChangePassword'))

export const { isLoading, setIsLoading } = createLoading()

export const actionPrefix = 'resource/v1/security/user'

export const callMeProfile = () => store.dispatch(`${actionPrefix}/meProfile`, {})
export const callMeProfileUpdate = ({ form }) => store.dispatch(`${actionPrefix}/meProfileUpdate`, { data: form })

export const onCallMeProfile = () => {
    setIsLoading(true)
    return callMeProfile().finally(() => setIsLoading(false))
}

export const onCallMeProfileUpdate = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true)
            return callMeProfileUpdate({ form: data.useForm.modelRef })
                .finally(() => setIsLoadingApp(false))
                .then(() => notification['success']({ message: i18n.global.t("views.profile.success") }))
        })
        .catch((error) => validateError({ error }));
}

export const createForm = () => {
    return {
        username: null,
        refImage: null,
        refTitle: null,
        firstNameTh: null,
        middleNameTh: null,
        lastNameTh: null,
        fullName: null,
        birthDate: null,
        email: null,
        idCard: null,
        phone: null,
        mobile: null,
        refDepartment: null,
        userRoles: [],
        userInsteads: [],
    }
}

export const createRules = () => {
    return {
        firstNameTh: [required],
    }
}

export const createField = ({ data }) => {
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return [
        createFieldImage({
            key: 'refImage',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 6, xl: 4 } }),
            label: () => i18n.global.t('model.user.refImage'),
            inputProp: () => ({ value: modelRef.refImage, 'onUpdate:value': value => modelRef.refImage = value, group: "Image" })
        }),
        {
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => { }
        },
        createFieldSelect({
            key: 'refTitle',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.lookup.modelGroup.TITLE'),
            inputProp: () => ({
                value: modelRef.refTitle,
                'onUpdate:value': value => modelRef.refTitle = value,
                list: ({ searchQuery }) => store.dispatch('resource/v1/master/lookup/cacheFindAllByGroup', { group: 'TITLE', value: searchQuery }),
                optLabel: "value",
            }),
            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
        }),
        createFieldInput({
            key: 'firstNameTh',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.firstNameTh'),
            inputProp: () => ({ value: modelRef.firstNameTh, 'onUpdate:value': value => modelRef.firstNameTh = value })
        }),
        createFieldInput({
            key: 'middleNameTh',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.middleNameTh'),
            inputProp: () => ({ value: modelRef.middleNameTh, 'onUpdate:value': value => modelRef.middleNameTh = value })
        }),
        createFieldInput({
            key: 'lastNameTh',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.lastNameTh'),
            inputProp: () => ({ value: modelRef.lastNameTh, 'onUpdate:value': value => modelRef.lastNameTh = value })
        }),
        createFieldDate({
            key: 'birthDate',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.birthDate'),
            inputProp: () => ({ value: modelRef.birthDate, 'onUpdate:value': value => modelRef.birthDate = value })
        }),
        createFieldInput({
            key: 'email',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.email'),
            inputProp: () => ({ value: modelRef.email, disabled: true })
        }),
        createFieldInputNumber({
            key: 'idCard',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.idCard'),
            inputProp: () => ({ value: modelRef.idCard, disabled: true, comma: false })
        }),
        createFieldInputNumber({
            key: 'phone',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.phone'),
            inputProp: () => ({ value: modelRef.phone, 'onUpdate:value': value => modelRef.phone = value, comma: false, maxDecimal: 10 })
        }),
        createFieldInputNumber({
            key: 'mobile',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.user.mobile'),
            inputProp: () => ({ value: modelRef.mobile, 'onUpdate:value': value => modelRef.mobile = value, comma: false, maxDecimal: 10 })
        }),
        createFieldTreeSelect({
            key: 'refDepartment',
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t('model.department.modelName'),
            inputProp: () => ({
                value: modelRef.refDepartment,
                disabled: true,
                list: () => store.dispatch('resource/v1/master/department/cacheFindAllWithChildren'),
                optLabel: "nameTh",
            }),
        }),
    ]
}

export const createFormTitle = () => {
    return i18n.global.t('button.profile')
}

export const loadForm = ({ data }) => {
    setIsLoading(true)
    let promise = callMeProfile().then(user => ({ data: [user] }))
    return promise
        .then(page => initUseForm({ data, page }))
        .finally(() => setIsLoading(false))
}

export const initForm = ({ props, data, refs }) => {
    data.form = createForm();
    data.rules = createRules();
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs })
        .then(() => {
            if (data?.form?.id) {
                data.userInsteads = {
                    fetchCriteria: {
                        select: ["**"],
                        page: 0,
                        size: 1000,
                        where: [{ name: "refUser.id", type: "UUID", operator: "=", value: data?.form?.id }],
                    },
                };
            }

            setAppPageHeader({
                slots: {
                    default: () => createAppPageHeaderDefault({ props, data, refs })
                }
            });
        })
}

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = []
    const col2 = []
    const { menuContext } = props
    col1.push(createButtonSave({ onClick: () => onCallMeProfileUpdate({ data }), classStyle: 'm-1' }))
    if (has({ menuContext, key: 'canChangePassword' })) {
        col2.push(<Button
            class="btn-warning m-1"
            size="small"
            onClick={() => openModalChangePassword({ props, data, refs })}
        >
            <span>{i18n.global.t("button.changePassword")}</span>
        </Button>)
    }
    return <Row type="flex">
        <Col>{col1}</Col>
        <Col class="ml-auto">{col2}</Col>
    </Row>
}

export const openModalChangePassword = ({ data, refs }) => {
    const options = addModal({
        bind: {
            ...modalStyleForm,
            title: i18n.global.t('views.changePassword.title'),
            width: '520px',
            okText: i18n.global.t('button.changePassword'),
            onOk: () => {
                refs.changePassword.onSubmit()
                    .then(() => {
                        notification['success']({ message: i18n.global.t("views.changePassword.success") })
                        options.bind.onCancel()
                    })
            }
        },
        render: () => <ChangePassword ref={(e) => { if (e) refs.changePassword = e }} id={data.id}></ChangePassword>
    })
    return options
}
